import React from 'react'

// This object is used to format content in the SearchableTableACDCNotCollapsed object.
// SpecialCurrencyFormat takes a currency name and an optional anchor tag and presents them in HTML format.
// The expected input for value is a string passing the name of a country.
// The expected input for footnote is a string
// When an anchor tag is passed, SpecialCurrencyFormat returns the currency name wrapped in an href.
// This href links to an anchor tag defined in CardCurrencySpecialCurrencies.
// When no anchor tag is passed, SpecialCurrencyFormat returns the currency name wrapped in div tags.
// isSpecialCurrency passes the anchor tag, and value passes the currency name.
// This checks whether an anchor tag value was passes into SpecialCurrencyFormat.
// SpecialCurrencyFormat doesn't check whether CardCurrencySpecialCurrencies is declared.
// Note: CurrenciesCell doesn't sanitize the input, so the values could be anything.
// Note: If CardCurrencySpecialCurrencies isn't declared in the same page that shows SpecialCurrencyFormat content, the link will not work.

const SpecialCurrencyFormat = (value, anchortag) => {
  const isSpecialCurrency = value.anchortag
  if (isSpecialCurrency) {
    return (
      <div>
        <a href={isSpecialCurrency}>{value.value}</a>
      </div>
    )
  }
  return <div>{value.value}</div>
}

export default SpecialCurrencyFormat
